import { AuthenticationLoggerServiceImpl } from "./authentication-logger";
import { LoggingService } from "../loggingSvc";
import { EntryStateService } from "./entry-state-service";
import { LogoutDialog } from "./logout-dialog";
import { LogoutService } from "./logout-service";
import { ServiceDeskConfig } from "../../Startup/serviceDeskConfig";
import app from "../../sdAppModule";

// @ngInject
app
  .service("authenticationLogger", AuthenticationLoggerServiceImpl)
  .service("entryStateService", EntryStateService)
  .service("logoutService", LogoutService)
  .component("logoutDialog", {
    controller: LogoutDialog,
    templateUrl: "../ServiceDesk/sdServices/authentication/logout-dialog.html"
  })
  .run(($window: ng.IWindowService, loggingService: LoggingService, sdConfig: ServiceDeskConfig) => {
    // The msal logger needs to be attached before the authentication logger's dependency on msalAuthenticationService
    // is created to get as many messages as possible
    AuthenticationLoggerServiceImpl.attachMsalLoggerToWindow(
      $window,
      loggingService,
      sdConfig.maxMessagesToLogFromMsal
    );
  })
  .run(LogoutService.subscribeLogoutCloseAllOtherWindowsEvent);
